import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "form" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "checkbox" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "action" }
const _hoisted_18 = { class: "message" }
const _hoisted_19 = { class: "text" }
const _hoisted_20 = { class: "action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Snackbar = _resolveComponent("Snackbar")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      (_ctx.organization.name !== '')
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, [
            _cache[12] || (_cache[12] = _createTextVNode(" 組織名: ", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.organization.name), 1)
          ]))
        : (_openBlock(), _createElementBlock("h1", _hoisted_3, "組織名")),
      _createVNode(_component_Snackbar, { option: _ctx.snackbar }, null, 8, ["option"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", null, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _cache[13] || (_cache[13] = _createElementVNode("th", null, "プロファイル名", -1)),
              _createElementVNode("td", null, [
                (_ctx.editName)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      type: "text",
                      class: "field",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.organization.name) = $event))
                    }, null, 512)), [
                      [_vModelText, _ctx.organization.name]
                    ])
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.organization.name), 1))
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[14] || (_cache[14] = _createElementVNode("th", null, "説明", -1)),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "field",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.organization.description) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.organization.description]
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[16] || (_cache[16] = _createElementVNode("th", null, "設定", -1)),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.kintone_data) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.kintone_data]
                    ]),
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "ms-2" }, "Kintone のデータ", -1))
                  ])
                ])
              ])
            ]),
            (_ctx.kintone_data)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                  _cache[17] || (_cache[17] = _createElementVNode("th", null, "Kintoneドメイン", -1)),
                  _createElementVNode("td", null, [
                    (_ctx.editName)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "text",
                          class: "field",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.organization.kintone_url) = $event))
                        }, null, 512)), [
                          [_vModelText, _ctx.organization.kintone_url]
                        ])
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.organization.kintone_url), 1))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.kintone_data)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                  _cache[18] || (_cache[18] = _createElementVNode("th", null, "Email", -1)),
                  _createElementVNode("td", null, [
                    (_ctx.editName)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "text",
                          class: "field",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.organization.kintone_email) = $event))
                        }, null, 512)), [
                          [_vModelText, _ctx.organization.kintone_email]
                        ])
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.organization.kintone_email), 1))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.kintone_data)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                  _cache[19] || (_cache[19] = _createElementVNode("th", null, "パスワード", -1)),
                  _createElementVNode("td", null, [
                    (_ctx.editName)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "text",
                          class: "field",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.organization.kintone_password) = $event))
                        }, null, 512)), [
                          [_vModelText, _ctx.organization.kintone_password]
                        ])
                      : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.organization.kintone_password), 1))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.edit && _ctx.organization.createdAt)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                  _cache[20] || (_cache[20] = _createElementVNode("th", null, "作成日時", -1)),
                  _createElementVNode("td", null, _toDisplayString(new Date(_ctx.organization.createdAt).toLocaleString()), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.edit && _ctx.organization.updatedAt)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                  _cache[21] || (_cache[21] = _createElementVNode("th", null, "更新日時", -1)),
                  _createElementVNode("td", null, _toDisplayString(new Date(_ctx.organization.updatedAt).toLocaleString()), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("nav", null, [
          (!_ctx.edit)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-secondary",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args))),
                disabled: _ctx.loading
              }, _toDisplayString(_ctx.loading ? '処理中…' : '追加'), 9, _hoisted_15))
            : _createCommentVNode("", true),
          (_ctx.edit)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-secondary",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args))),
                disabled: _ctx.loading
              }, _toDisplayString(_ctx.loading ? '処理中…' : '編集'), 9, _hoisted_16))
            : _createCommentVNode("", true),
          (_ctx.edit && _ctx.editName && _ctx.loggedInUser.role === _ctx.AccountRole.SUPER_ADMIN)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "btn btn-danger",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
              }, "削除 "))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      ref: "remove",
      class: "dialog"
    }, {
      default: _withCtx(() => [
        _cache[22] || (_cache[22] = _createElementVNode("h4", { class: "title" }, "Confirm", -1)),
        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "message" }, [
          _createElementVNode("p", { class: "text" }, "Do you really remove this organization?")
        ], -1)),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            class: "btn btn-light",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.removeCancel && _ctx.removeCancel(...args)))
          }, "Cancel"),
          _createElementVNode("button", {
            class: "btn btn-danger",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.removeConfirmed && _ctx.removeConfirmed(...args)))
          }, "削除")
        ])
      ]),
      _: 1,
      __: [22,23]
    }, 512),
    _createVNode(_component_Dialog, {
      ref: "error",
      class: "dialog"
    }, {
      default: _withCtx(() => [
        _cache[24] || (_cache[24] = _createElementVNode("h4", { class: "title" }, "Error", -1)),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.error.message), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("button", {
            class: "btn btn-light",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.errorClose && _ctx.errorClose(...args)))
          }, "Close")
        ])
      ]),
      _: 1,
      __: [24]
    }, 512)
  ], 64))
}